export default "__VITE_ASSET__hBRE9LC7__"